<template>
  <div class="gift">
    <div class="selectNumber w-full bg-red-200 px-10 py-4 mb-3">
      <!-- web -->
      <h5 class="m-0 hidden md:block text-NotoSansRegular">贈品：您已選了<span>{{ selectedGifts.length }}</span>件商品，還可再選
        <span>{{ remainGiftSelect }}</span>件商品</h5>

        <!-- mobile -->
      <h5 class="m-0 md:hidden">贈品：您可選 <span>{{ selectedGifts.length }}</span>/
        <span>{{ remainGiftSelect }}</span>件商品</h5>
    </div>
    <div class="flex giftList" style="min-height: 247px">
      <div class="w-full">
        <div class="container relative">
          <swiper :options="freeGiftOption" class="swiper h-full">
            <swiper-slide v-for="(item, index) in planGifts" :key="index" :class="{ selected: selectedGifts.indexOf(item.id) !== -1 }" class="pt-3 pb-2 item cursor-pointer h-auto">
              <label @click="selectItem(item)" :for="'radio-input-' + selectedGifts.indexOf(item.id)" class="w-full h-full input-helper input-helper--radio cursor-pointer">
                <div class="gift-inner border-2 border-solid bg-white" :class="{ 'opacity-25': item.in_stock < 1}">
                  <div v-if="item.cover!==''" class="square-img" v-lazy:background-image="{ src: item.cover }"></div>
                  <div v-if="item.cover===''" class="square-img square-img-none"></div>
                </div>
                <div class="giftName text-NotoSansRegular text-sm text-left mt-1 w-10/12 mx-auto">
                  <font-awesome-icon :icon="['far', 'check-square']" v-if="selectedGifts.indexOf(item.id) !== -1" />
                  <font-awesome-icon :icon="['far', 'square']" v-else />
                  <span class="text-left leading-normal ml-1">{{ item.name }}</span>
                </div>
              </label>
            </swiper-slide>

          </swiper>
          <div class="swiper-button-next swiper-button-next-gift focus:outline-none cursor-pointer py-16 mt-0 md:hidden"></div>
          <div class="swiper-button-prev swiper-button-prev-gift focus:outline-none cursor-pointer py-16 mt-0 md:hidden"></div>
          <div class="swiper-button-next swiper-button-next-gift focus:outline-none cursor-pointer py-16 mt-0 hidden md:block" v-if="planGifts.length > 4"></div>
          <div class="swiper-button-prev swiper-button-prev-gift focus:outline-none cursor-pointer py-16 mt-0 hidden md:block" v-if="planGifts.length > 4"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import sweetAlert from '@/components/modules/sweetAlert'
export default {
  name: 'FreeGift',

  props: {
    planGifts: {
      type: Array
    },
    gift_num: {
      type: Number
    }
  },
  mixins: [
    sweetAlert
  ],
  data () {
    return {
      renderComponent: true,
      selectedGifts: [],
      freeGiftOption: {
        slidesPerView: 4,
        spaceBetween: 5,
        loop: false,
        navigation: {
          nextEl: '.swiper-button-next-gift',
          prevEl: '.swiper-button-prev-gift'
        },
        breakpoints: {
          576: {
            slidesPerView: 2,
            spaceBetween: 5
          }
        }
      }
    }
  },
  watch: {
    gift_num: {
      handler (newValue, oldValue) {
        let self = this
        if (newValue !== oldValue) {
          self.selectedGifts = []
        }
      }
    }
  },

  computed: {
    remainGiftSelect () {
      if (this.planGifts !== null) {
        return this.gift_num - this.selectedGifts.length
      } else {
        return 0
      }
    }
  },
  methods: {
    selectItem (item) {
      let self = this
      if (item.in_stock > 0) {
        if (self.remainGiftSelect > 0 && self.selectedGifts.indexOf(item.id) === -1) {
          self.selectedGifts.push(item.id)
        } else if (self.selectedGifts.indexOf(item.id) !== -1) {
          self.selectedGifts.splice(self.selectedGifts.indexOf(item.id), 1)
        } else if (self.remainGiftSelect === 0 && self.selectedGifts.indexOf(item.id) === -1) {
          self.alertPop('warning', `贈品只能選擇 ${self.gift_num} 件，若要更改，請先取消已勾選的贈品`)
          // self.$store.dispatch('updateAlert', { isAlert: true, isHead: true, alertMsg: '贈品只能選擇' + self.gift_num + '件，若要更改，請先取消已勾選的贈品', type: 'alert' })
        }
        self.emitItem()
      } else {
        self.$swal.fire({
          icon: 'info',
          title: 'Oops...',
          text: `${item.name} 已贈送完畢`
        })
      }
    },
    emitItem () {
      let self = this
      self.$emit('getSelectGift', self.selectedGifts)
    }
  }
}
</script>

<style lang="scss" scoped>
  .swiper-button-next-gift {
    right: -0.5rem;
    background-image: url('~@/assets/btn/arrowRight.png');
    width: 40px !important;
    height: 100% !important;
    transform: translateY(-50%);
    margin-top: 0 !important;
    background-size: 30px 30px !important;
    background-position: center;
    @media (min-width: 576px) {
      width: 5% !important;
    }
  }
  .swiper-button-prev-gift {
    left: -0.5rem;
    background-image: url('~@/assets/btn/arrowLeft.png');
    width: 40px !important;
    height: 100% !important;
    transform: translateY(-50%);
    margin-top: 0 !important;
    background-size: 30px 30px !important;
    background-position: center;
    @media (min-width: 576px) {
      width: 5% !important;
    }
  }
  .gift {
    .gift-inner {
      margin: 0 auto;
      position: relative;
      width: 85%;
      padding-bottom : 85%;
      background-position: center center;
      background-repeat: no-repeat;
      background-size: cover;
      background-color: white;
      .square-img {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 90%;
        padding-bottom : 90%;
        background-position: center center;
        background-repeat: no-repeat;
        background-size: contain;
      }
      .square-img-none {
        background-image: url('~@/assets/images/preset_item.png');
      }
    }
    .selectNumber {
      h5 {
        font-weight: 400;
        font-size: 14px;
        color: #434343;
        letter-spacing: .2rem;
      }
    }
    .giftList {
      .selected {
        background: pink;
        height: 100%;
      }
    }
  }
</style>
